import React from 'react';

interface EduCardProps {
  title?: React.ReactNode;
  subtitle?: React.ReactNode;
  action?: React.ReactNode;
  children: React.ReactNode;
  className?: string;
  footer?: React.ReactNode;
}

export const EduCard: React.FC<EduCardProps> = ({
  title,
  subtitle,
  action,
  children,
  className = '',
  footer,
}) => {
  return (
    <div
      className={`bg-surface border border-bdr rounded-xl shadow-sm hover:shadow-md transition-shadow duration-200 overflow-hidden ${className}`}
    >
      {(title || action) && (
        <div className="px-6 py-4 border-b border-bdr flex items-center justify-between gap-4">
          <div>
            {title && (
              <h3 className="text-base font-semibold text-txt-primary">
                {title}
              </h3>
            )}
            {subtitle && (
              <p className="text-xs text-txt-secondary mt-0.5">{subtitle}</p>
            )}
          </div>
          {action && <div className="flex items-center gap-2">{action}</div>}
        </div>
      )}
      <div className="p-6">{children}</div>
      {footer && (
        <div className="px-6 py-3 bg-surface-secondary border-t border-bdr text-xs text-txt-secondary flex items-center justify-between">
          {footer}
        </div>
      )}
    </div>
  );
};
